module.exports = __webpack_public_path__ + "static/media/img_3.a3276a85.png";